import type { ActionFunction } from '@remix-run/node';
import { json } from '@remix-run/node';
import type {
    CommentMarkAsUnreadMutation,
    CommentMarkAsUnreadMutationVariables,
} from 'generated/graphql';
import { CommentMarkAsUnreadDocument } from 'generated/graphql';

export const COMMENT_MARK_AS_UNREAD_API_ROUTE =
    '/remix-api/app/build-hub-comment-mark-as-unread';

export const action: ActionFunction = async ({ request, context }) => {
    const formData = await request.formData();
    const documentID = formData.get('documentID');
    const commentID = formData.get('commentID');

    if (!documentID || typeof documentID !== 'string') {
        return json({ error: 'Document ID is required' }, { status: 400 });
    }

    try {
        const variables: CommentMarkAsUnreadMutationVariables = {
            DocumentID: documentID,
        };

        // Add optional CommentID if provided
        if (commentID && typeof commentID === 'string') {
            variables.CommentID = commentID;
        }

        const { data } = await context.client.mutate<
            CommentMarkAsUnreadMutation,
            CommentMarkAsUnreadMutationVariables
        >({
            mutation: CommentMarkAsUnreadDocument,
            variables,
        });

        return json(data);
    } catch (error) {
        console.error('Error marking comment as unread:', error);
        return json({ error: 'Failed to mark as unread' }, { status: 500 });
    }
};
